module.exports = __webpack_public_path__ + "img/gl_penguin.51c2e4da.png";